import React, { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { Text } from "@/components/Text";
import { Flex, IFlexProps } from "@/eworkitComponents";

import emptyStateImg from "./empty-state-icon.svg";

export interface IInfoboxProps extends IFlexProps {
  imgSrc?: string;
  heading?: ReactNode;
  description?: ReactNode;
}

export const Infobox: FC<IInfoboxProps> = ({ imgSrc, heading, description, children, ...flexProps }) => {
  const { t } = useTranslation("common");

  return (
    <Flex direction="column" align="center" justify="center" innerMargin="xs" {...flexProps}>
      <Flex padding={[false, false, "md", false]}>
        <img src={imgSrc ? imgSrc : emptyStateImg} width={128} height={128} />
      </Flex>

      {!!heading && (
        <Header size="sm" color="black" align="center">
          {heading || t("MESSAGES.NO_RESULTS_FOUND")}
        </Header>
      )}

      {!!description && (
        <Text size="md" color="grey1" align="center">
          {description}
        </Text>
      )}

      {children}
    </Flex>
  );
};
